import React, { useState } from "react";
import { useConfig } from "../../contexts/ConfigContext";
import { useLanguage } from "../../contexts/LanguageContext";
import { LightMode, ToolType } from "../../types";
import CanvasTools from "./CanvasTools";
import VanillaThreeViewer from "./VanillaThreeViewer";
import "./MainCanvas.css";

const MainCanvas: React.FC = () => {
  const [currentTool, setCurrentTool] = useState<ToolType>(null);
  const [drawingColor, setDrawingColor] = useState<string>("#0099ff");
  const [lightMode, setLightMode] = useState<LightMode>("studio");
  const [lightIntensity, setLightIntensity] = useState(1);

  const handleLightModeChange = (mode: LightMode) => {
    setLightMode(mode);
    setLightIntensity(1);
  };

  const { getVisibleModelsInGroup } = useConfig();
  const { t } = useLanguage();

  const visibleModels = getVisibleModelsInGroup();

  const clearDrawing = (): void => {
    // Функция будет переопределена в VanillaThreeViewer
  };

  const takeScreenshot = (): void => {
    // Функция будет переопределена в VanillaThreeViewer
  };

  return (
    <div className="canvas-container">
      <CanvasTools
        currentTool={currentTool}
        onToolChange={setCurrentTool}
        onClearDrawing={clearDrawing}
        onTakeScreenshot={takeScreenshot}
        drawingColor={drawingColor}
        onColorChange={setDrawingColor}
        lightMode={lightMode}
        onLightModeChange={handleLightModeChange}
        lightIntensity={lightIntensity}
        onLightIntensityChange={setLightIntensity}
      />

      <div className="canvas-area">
        {visibleModels.length > 0 ? (
          <VanillaThreeViewer
            models={visibleModels}
            currentTool={currentTool}
            onClearDrawing={clearDrawing}
            onTakeScreenshot={takeScreenshot}
            drawingColor={drawingColor}
            lightMode={lightMode}
            lightIntensity={lightIntensity}
          />
        ) : (
          <div className="canvas-placeholder">
            <div className="empty-state">
              <div className="empty-icon">📦</div>
              <p>{t("no_models_selected")}</p>
              <small>{t("select_models_help")}</small>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MainCanvas;
